const referenzen = [
  {
    id: 1,
    title: "Wohnhaus Eberswalde",
    description: "Kompletter Innenausbau mit Trockenbau und Bodenbelägen",
    image: "https://images.unsplash.com/photo-1631889477974-6394c9988436?w=600&q=80"
  },
  {
    id: 2,
    title: "Büroräume Berlin",
    description: "Deckensysteme und Trennwände für modernes Bürokonzept",
    image: "https://images.unsplash.com/photo-1708861617521-5fb2915b69e4?w=600&q=80"
  },
  {
    id: 3,
    title: "Dachgeschossausbau",
    description: "Vollständiger Ausbau mit Dämmung und Trockenbau",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80"
  },
  {
    id: 4,
    title: "Gewerberäume Bernau",
    description: "Brandschutzverkleidungen und Akustikdecken",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=600&q=80"
  },
  {
    id: 5,
    title: "Praxisräume",
    description: "Trockenbau und hochwertige Bodenbeläge",
    image: "https://images.unsplash.com/photo-1560749003-f4b1e17e2dff?w=600&q=80"
  },
  {
    id: 6,
    title: "Wohnanlage Finowfurt",
    description: "Trockenstrich und Montagearbeiten für Neubau",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80"
  }
];

const ReferenzenPage = () => {
  return (
    <div data-testid="referenzen-page" style={{ backgroundColor: '#372d24' }}>
      {/* Hero Section */}
      <section className="pt-12 pb-6" style={{ backgroundColor: '#372d24' }} data-testid="referenzen-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Unsere Referenzen
            </h1>
            <p className="text-lg leading-relaxed" style={{ color: '#dbcebe' }}>
              Überzeugen Sie sich von unserer Arbeit. Hier finden Sie eine Auswahl unserer erfolgreich abgeschlossenen Projekte.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-8 pb-16" style={{ backgroundColor: '#372d24' }} data-testid="referenzen-gallery">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {referenzen.map((projekt) => (
              <div 
                key={projekt.id}
                className="group rounded-2xl overflow-hidden border border-[#4a3d32] hover:border-amber-500/50 transition-all"
                style={{ backgroundColor: '#2a2219' }}
              >
                <div className="overflow-hidden">
                  <img 
                    src={projekt.image} 
                    alt={projekt.title}
                    className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-lg font-semibold mb-2" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
                    {projekt.title}
                  </h3>
                  <p className="text-sm" style={{ color: '#a89f94' }}>
                    {projekt.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReferenzenPage;
